import {
  ApplicationConfig,
  inject,
  Injectable,
  isDevMode,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  TitleStrategy,
  withInMemoryScrolling,
} from '@angular/router';

import { routes, TranslatedTitleStrategy } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
  withFetch,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideLottieOptions } from 'ngx-lottie';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import {
  provideTransloco,
  Translation,
  TranslocoLoader,
} from '@jsverse/transloco';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { WebsiteService } from '@shared/services/website.service';
import { EnvironmentService } from '@shared/services/environment.service';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  cookieService = inject(SsrCookieService);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`./i18n/${lang}.json`);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideTransloco({
      config: {
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        fallbackLang: 'en',
        defaultLang: 'ar',
      },
      loader: TranslocoHttpLoader,
    }),
    provideAppInitializer(() => {
      const websiteService = inject(WebsiteService);
      websiteService.initiazeAppSettings();
    }),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideAnimations(),
    provideEnvironmentNgxMask(),
    provideClientHydration(withEventReplay()),
    {
      provide: TitleStrategy,
      useClass: TranslatedTitleStrategy,
    },
  ],
};
